import { memo } from "react";
import { Routes as RoutesWrapper, Route } from "react-router-dom";
import '../style.css';
import { Users, Roles, ChangePassword, ServiceTypes, ServiceCategories, HomePage, ProvidersRR, ProvidersRRDetails, ProviderProfile, DoctorDetails, DoctorReport, CreateDoctor, MedicalRequest, PatientRequestDetails, AddQuotation, Admission, PostServiceEntry, BrokerRegistration, PatientsListGroups } from "@pages/Exporter";

const AuthedRoutes = () => {



  return (
    <RoutesWrapper>
      <Route path="panel/*" element={
        <RoutesWrapper>
          <Route path="/" element={<HomePage />} />
          <Route path="users" element={<Users />} />
          <Route path="roles" element={<Roles />} />
          <Route path="change-password" element={<ChangePassword />} />
          <Route path="service-types" element={<ServiceTypes />} />
          <Route path="service-category" element={<ServiceCategories />} />
          <Route path="providers-request" element={<ProvidersRR />} />
          <Route path="request-details/:id" element={<ProvidersRRDetails />} />
          <Route path="provider-profile" element={<ProviderProfile />} />

          <Route path="provider/doctors" element={<DoctorReport />} />
          <Route path="provider/doctors/create" element={<CreateDoctor />} />
          <Route path="provider/doctors/details/:doctorId" element={<DoctorDetails />} />
          <Route path="provider/requests/medical" element={<MedicalRequest />} />
          <Route path="provider/medical-request/:id/:statusId" element={<PatientRequestDetails />} />
          <Route path="provider/medical-request/add-quotation" element={<AddQuotation />} />
          <Route path="provider/medical-request/admission" element={<Admission />} />
          <Route path="provider/medical-request/post-service-entry" element={<PostServiceEntry />} />
          
          <Route path="broker/registration" element={<BrokerRegistration />} />
          <Route path="broker/clients/report" element={<PatientsListGroups />} />

        </RoutesWrapper>
      } />
    </RoutesWrapper>
  );
};

export default memo(AuthedRoutes);